import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'notifications.title',
  },
  empty_message: {
    id: 'notifications.empty.message',
  },
  notifications: {
    id: 'notifications.title',
  },
});
